import(/* webpackMode: "eager" */ "/home/runner/work/aero-template-base/aero-template-base/apps/web/app/login/forgot-password/page.tsx");
